import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actions from '../../../actions/get-quotes';
import GetQuotesWidget from './GetQuotesWidget';
import { Container, Row, Col } from 'hui';

const GQWidgetContainer = styled(Container)`
  padding: 0 20px;
`;

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export class Index extends Component<any, any> {
  static propTypes = {
    category: PropTypes.object,
    categoryPersonPlural: PropTypes.string,
    actions: PropTypes.object
  };

  static defaultProps = {
    categoryPersonPlural: 'Trade Professionals'
  };

  render() {
    const { category, categoryPersonPlural } = this.props;
    const { submitSelection } = this.props.actions;

    return (
      <GQWidgetContainer>
        <Row>
          <Col xs={12}>
            <GetQuotesWidget
              category={category}
              categoryPersonPlural={categoryPersonPlural}
              submitSelection={submitSelection}
            />
          </Col>
        </Row>
      </GQWidgetContainer>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
